'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCentrePoint = exports.getTopLeftPoint = undefined;

var _point = require('./point');

var getTopLeftPoint = exports.getTopLeftPoint = function getTopLeftPoint(measurements) {
    return (0, _point.getPoint)(measurements.left, measurements.top);
};

var getCentrePoint = exports.getCentrePoint = function getCentrePoint(measurements) {
    return (0, _point.getPoint)(measurements.left + measurements.width / 2, measurements.top + measurements.height / 2);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/measurements.js
// module id = 2279
// module chunks = 0